import Icon from '../components/Icon.vue'

Icon.register({
  'file-invoice': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M288 256v64h-192v-64h192zM377 105c4.5 4.5 7 10.6 7 16.9v6.1h-128v-128h6.1c6.4 0 12.5 2.5 17 7zM224 136c0 13.2 10.8 24 24 24h136v328c0 13.3-10.7 24-24 24h-336c-13.3 0-24-10.7-24-24v-464c0-13.3 10.7-24 24-24h200v136zM64 72v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zM64 136v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zM320 440v-16c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8zM320 240c0-8.8-7.2-16-16-16h-224c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16v-96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-invoice.js
// module id = 1339
// module chunks = 0